const cards = [
  {
    title: '千万粉主播"XX"人设崩塌始末：从粉丝心中的完美偶像到全网群嘲',
    desc: '一个月前还被粉丝捧上神坛的头部主播，因一次直播口误被扒出学历造假、慈善造假等一系列黑料。随着越挖越多，这场塌房大戏从单一人设崩塌演变成涉及虚假宣传、偷税漏税、合同诈骗的多重指控。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20broken%20crown%20on%20dark%20pedestal%2C%20dramatic%20lighting%2C%20cracks%20and%20fractures%2C%20crimson%20and%20gold%20accents%2C%20symbolic%20representation%20of%20fallen%20reputation%2C%20dark%20atmospheric%20fine%20art%20photography&width=800&height=500&seq=card-01&orientation=landscape',
    tag: '塌房实锤',
    date: '2026-07-28',
    heat: '42.3w',
  },
  {
    title: '快手百万粉情感博主被实锤：所谓"情感导师"实为PUA操控者',
    desc: '多名女粉丝联合爆料，指控该博主利用情感咨询名义建立私人关系后实施精神操控和财务诈骗。聊天记录、转账凭证等证据陆续曝光，目前已有超过20位受害者站出发声。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20shadow%20puppet%20strings%20concept%2C%20abstract%20figure%20behind%20translucent%20screen%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20crimson%20undertones%2C%20atmospheric%20and%20foreboding%2C%20conceptual%20fine%20art%20photography&width=800&height=500&seq=card-02&orientation=landscape',
    tag: '深度扒皮',
    date: '2026-07-27',
    heat: '38.7w',
  },
  {
    title: '美妆博主代工厂全揭秘：你花500买的"高端"，成本不到30',
    desc: '暗访调查团队历时三个月，追踪某头部美妆博主的供应链全流程。从代工厂生产到品牌贴标再到直播定价，一条完整的割韭菜产业链浮出水面，毛利高达15倍以上。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20industrial%20assembly%20line%20with%20unlabeled%20cosmetic%20bottles%2C%20conveyor%20belt%2C%20dim%20amber%20lighting%2C%20mysterious%20factory%20atmosphere%2C%20investigative%20documentary%20style%2C%20high%20contrast%2C%20cinematic&width=800&height=500&seq=card-03&orientation=landscape',
    tag: '业内曝光',
    date: '2026-07-25',
    heat: '35.1w',
  },
  {
    title: '经纪公司霸王合同曝光：网红的光鲜背后是吃人的商业模式',
    desc: '一份匿名的网红经纪合约在业内群流传，其中包含长达10年的独家期、收益九一分成、竞业限制遍布全行业、违约金高达年收入50倍等条款，引爆全网关于MCN行业规范化的讨论。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20closeup%20of%20crisp%20legal%20documents%20with%20red%20highlighting%2C%20gold%20pen%2C%20deep%20shadows%2C%20atmospheric%20office%20setting%2C%20cinematic%20photography%2C%20corporate%20noir%20aesthetic&width=800&height=500&seq=card-04&orientation=landscape',
    tag: '合同陷阱',
    date: '2026-07-23',
    heat: '29.4w',
  },
  {
    title: '舞蹈区网红私生活混乱事件升级：涉及未成年人引发法律追责',
    desc: '此前被曝光的私生活混乱事件出现重大升级，新增爆料涉及与未成年人相关的不当行为。目前已知多家合作品牌已宣布解约，相关当事人已被平台封禁，多地警方介入调查。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20legal%20scale%20of%20justice%2C%20fractured%20and%20imbalanced%2C%20dramatic%20crimson%20and%20shadow%20lighting%2C%20atmospheric%20tension%2C%20symbolic%20conceptual%20art%2C%20fine%20art%20photography%20style&width=800&height=500&seq=card-05&orientation=landscape',
    tag: '法律追责',
    date: '2026-07-22',
    heat: '56.8w',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">深度爆料</h2>
            <p className="mt-2 text-sm text-foreground-500">图文并茂的网红黑料专题报道，每一篇都值得细品</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {cards.map((card, idx) => (
              <div
                key={idx}
                className={`group cursor-pointer rounded-xl overflow-hidden bg-background-200/70 border border-background-300/40 transition-all duration-300 hover:border-primary-500/30 ${
                  idx === 0 ? 'md:col-span-2 lg:col-span-2' : ''
                }`}
              >
                <div className={idx === 0 ? 'grid grid-cols-1 sm:grid-cols-2' : ''}>
                  <div className="relative aspect-video overflow-hidden">
                    <img
                      src={card.img}
                      alt={card.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="inline-block text-xs font-medium px-2.5 py-1 rounded-full bg-primary-500/85 text-background-50 whitespace-nowrap">
                        {card.tag}
                      </span>
                    </div>
                  </div>
                  <div className="p-5 flex flex-col">
                    <h3 className="text-base font-semibold text-foreground-900 leading-snug group-hover:text-primary-400 transition-colors duration-200">
                      {card.title}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-3">
                      {card.desc}
                    </p>
                    <div className="mt-auto pt-4 flex items-center justify-between text-xs text-foreground-400">
                      <span>{card.date}</span>
                      <span className="flex items-center gap-1">
                        <span className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-fire-line text-xs text-primary-500"></i>
                        </span>
                        {card.heat} 热度
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}